@switch (imageVariant()) {
	@case ('single') {
		@if (images()?.length) {
			<div class="relative h-full w-28 min-w-full md:w-44 lg:w-64">
				<vp-image
					[className]="
						cn(imageClass(), 'aspect-square md:aspect-video')
					"
					[image]="{
						src: images()![0].src,
						altText: images()![0].alt,
						width: 652,
						height: 460,
					}"
					className="size-full"
					sizes="auto, 100vw"
				/>
				@if (imageRibbon()) {
					<div
						class="absolute -left-4 top-4 whitespace-nowrap sm:-left-5 sm:top-5"
					>
						<vp-ribbon
							[maxLength]="15"
							[text]="imageRibbon()"
							color="yellow"
						/>
					</div>
				}
			</div>
		}
	}

	@case ('mini-carousel') {
		<vp-mini-carousel
			[aspectRatio]="aspectRatio()"
			[className]="
				useVerticalCard()
					? 'card-image-border-radius-t'
					: 'card-image-border-radius-t md:card-image-border-radius-l'
			"
			[dynamicHeight]="dynamicHeight()"
			[items]="carouselItems()"
			class="h-auto min-w-full"
		/>
	}

	@case ('grid') {
		<vp-image-grid
			[className]="
				useVerticalCard()
					? 'card-image-border-radius-t'
					: 'card-image-border-radius-t md:card-image-border-radius-l'
			"
			[images]="images() || []"
			[size]="gridSize()"
		/>
	}
}
